import React from "react";

import { Box, BoxSx } from "../..";
import { CaretDown } from "./caret-down";

export const CaretUp: React.FC<{ fill?: "filled" | "none" }> = ({
  fill = "none"
}) => {
  const caretUpStyles: BoxSx = {
    display: "flex",
    transform: "rotate(180deg)",
    transformOrigin: "center"
  };

  if (fill === "filled") {
    return (
      <Box as="span" sx={caretUpStyles}>
        <CaretDown fill="filled" />
      </Box>
    );
  }

  return (
    <Box as="span" sx={caretUpStyles}>
      <CaretDown />
    </Box>
  );
};
